export default __webpack_public_path__ + "static/media/En-distribución.b3de57bd.svg";